import * as React from 'react';

// Lowered from 1280 → 1024 so small MacBooks / 13" laptops get the desktop
// surface (floating ChatPanel, header nav, etc.) instead of the mobile drawer.
const MOBILE_BREAKPOINT = 1024;

// Initialize synchronously so the first paint already knows the form factor.
// Prevents the desktop-layout flash on mobile (especially slow Android).
const getInitialIsMobile = (): boolean => {
	if (typeof window === 'undefined') return false;
	return window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`).matches;
};

export function useIsMobile() {
	const [isMobile, setIsMobile] = React.useState<boolean>(getInitialIsMobile);

	React.useEffect(() => {
		const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
		const onChange = () => setIsMobile(mql.matches);
		mql.addEventListener('change', onChange);
		// Sync once in case the breakpoint flipped between render and effect.
		setIsMobile(mql.matches);
		return () => mql.removeEventListener('change', onChange);
	}, []);

	return isMobile;
}
